import React from "react";
import * as constants from "../../../../EventSettings/constants";
import { availableTypesBackground } from "../../../../EventSettings/models";
import TextSetting from "../TextSetting";
import HideSetting from "../HideSetting";
import CPSettingUploadImage from "../../../../../UI/Settings/CPSettingUploadImage";

const ScreenInfo = ({ moduleSettings, posterImage, onUpdate }) => {
    return (
        <>
            <HideSetting
                eventSetting={moduleSettings}
                title="Скрывать левый блок"
                name={constants.SETTINGS_HIDE_INFO_BLOCK}
                value={moduleSettings[constants.SETTINGS_HIDE_INFO_BLOCK]}
                onUpdate={onUpdate}
            />
            {!moduleSettings[constants.SETTINGS_HIDE_INFO_BLOCK] && (
                <>
                    <p style={{fontSize: '12px', fontStyle: 'italic'}}>
                        <b>{'{{eventName}}'}</b> - название мероприятия,<br />
                        <b>{'{{dateStart}}'}</b> - дата начала мероприятия,<br />
                        <b>{'{{dateStop}}'}</b> - дата окончания мероприятия,<br />
                        <b>{'{{timeStart}}'}</b> - время начала мероприятия,<br />
                        <b>{'{{timeStop}}'}</b> - время окончания мероприятия
                    </p>
                    <CPSettingUploadImage
                        eventImage={posterImage}
                        title="Постер"
                        settingName={constants.SETTINGS_POSTER_IMAGE}
                        availableTypes={availableTypesBackground}
                        onUpdate={onUpdate}
                    />
                    <TextSetting
                        eventSetting={moduleSettings}
                        title="Название мероприятия"
                        property={constants.SETTINGS_EVENT_TITLE}
                        toggleProperty={constants.SETTINGS_HIDE_EVENT_TITLE}
                        onUpdate={onUpdate}
                    />
                    <TextSetting
                        eventSetting={moduleSettings}
                        title="Подзаголовок"
                        property={constants.SETTINGS_EVENT_SUBTITLE}
                        toggleProperty={constants.SETTINGS_HIDE_EVENT_SUBTITLE}
                        onUpdate={onUpdate}
                    />
                    <TextSetting
                        eventSetting={moduleSettings}
                        title="Дата и время"
                        property={constants.SETTINGS_DATE}
                        toggleProperty={constants.SETTINGS_HIDE_DATE}
                        onUpdate={onUpdate}
                    />
                    <HideSetting
                        eventSetting={moduleSettings}
                        title="Скрыть формат"
                        name={constants.SETTINGS_HIDE_FORMAT}
                        value={moduleSettings[constants.SETTINGS_HIDE_FORMAT]}
                        onUpdate={onUpdate}
                    />
                </>
            )}
        </>
    )
};

export default ScreenInfo;
